import { Theme } from '@mui/material';
import { ReactComponent as PendingIcon } from '../../../../static/icons/ic_pending.svg';
import { ReactComponent as RejectIcon } from '../../../../static/icons/ic_cancel.svg';
import { ReactComponent as CheckIcon } from '../../../../static/icons/ic_check.svg';

const STATUS_ICONS_MAP: { [key: string]: any } = {
  Pending: {
    icon: PendingIcon,
  },
  Approved: {
    icon: CheckIcon,
  },
  Declined: {
    icon: RejectIcon,
  },
} as const;

const statusColorMap = (theme: Theme): { [key: string]: string } => ({
  Pending: theme.palette.warning.main,
  Approved: theme.palette.success.main,
  Declined: theme.palette.error.main,
});

const typeColorMap: { [key: string]: string } = {
  Vacation: 'rgb(34, 197, 94)',
  Other: 'rgb(0, 184, 217)',
  'Sick leave': 'rgb(161, 94, 0)',
};

const textColorToDarkestMap: { [key: string]: string } = {
  'rgb(34, 197, 94)': '#020d06',
  'rgb(0, 184, 217)': 'rgb(0, 41, 0)',
  'rgb(255, 171, 0)': 'rgb(102, 48, 0)',
};

export {
  STATUS_ICONS_MAP,
  statusColorMap,
  typeColorMap,
  textColorToDarkestMap,
};
